// 시트(상세·폼) — SCREENS §0: compact 아래에서 올라오는 전체 폭 · medium 가운데 대화상자(최대 560) · expanded 오른쪽 420 · large 오른쪽 480
import { useEffect, useRef, type ReactNode } from "react";
import { useWidthClass } from "./hooks";
import { Icon } from "./icons";

export function Sheet({ title, onClose, children, footer }: { title: string; onClose: () => void; children: ReactNode; footer?: ReactNode }) {
  const wc = useWidthClass();
  const ref = useRef<HTMLDivElement>(null);
  const closeRef = useRef(onClose);
  closeRef.current = onClose;
  useEffect(() => {
    const on = (e: KeyboardEvent) => { if (e.key === "Escape") closeRef.current(); };
    window.addEventListener("keydown", on);
    const prev = document.activeElement as HTMLElement | null;
    ref.current?.focus();
    document.body.classList.add("sheet-open");
    return () => { window.removeEventListener("keydown", on); document.body.classList.remove("sheet-open"); prev?.focus?.(); };
  }, []);
  const kind = wc === "compact" ? "bottom" : wc === "medium" ? "dialog" : "side";
  return (
    <div className={"sheet-wrap sheet-" + kind} role="presentation" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="sheet" role="dialog" aria-modal="true" aria-label={title} tabIndex={-1} ref={ref}>
        <header className="sheet-h">
          <h2>{title}</h2>
          <span className="grow" />
          <button type="button" className="btn btn-icon btn-ghost" aria-label="닫기" onClick={onClose}><Icon name="close" /></button>
        </header>
        <div className="sheet-body">{children}</div>
        {footer ? <footer className="sheet-f">{footer}</footer> : null}
      </div>
    </div>
  );
}
